<template>
  <div class="dlnkforums_component w-100">

    <div id="page_sections" v-if="page=='sections'">

      <div v-if="message" id="alert_message" class="alert alert-dismissible alert-modal" role="alert"
           :class="message_type">
        <button type="button" class="close" aria-label="Close" @click="close_message()">
          <span aria-hidden="true">&times;</span>
        </button>
        <span v-html="message"></span>
      </div>

      <div class="page-header">
        <h1>Racine du forum</h1>
      </div>

      <div v-if="admin || group_status == 0 || group_status == 1"
           class="modal fade text-body" id="section_modal" tabindex="-1" role="dialog"
           aria-labelledby="new_section_modalLabel">
        <form id="section_form"
              method="post"
              @submit.prevent="submit_section">
          <input type="hidden" name="section[group_id]" :value="group_id">
          <input type="hidden" name="section[status]" :value="'online'">
          <input type="hidden" name="section[author_id]" :value="customer_id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="new_section_modalLabel">{{modal_title}}</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Fermer"><span
                    aria-hidden="true">&times;</span></button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="section_name" class="required">Titre :</label>
                  <input id="section_name" name="section[name]" type="text"
                         class="form-control"
                         :class="{'is-invalid': errors.name}"
                         @blur="validate_name"
                         v-model="name">
                  <div class="invalid-feedback">
                    Le titre de la section doit contenir entre 3 et 128 caractères.
                  </div>
                </div>

                <div class="form-group">
                  <label for="section_description">Description&nbsp;:</label>
                  <textarea id="section_description" name="section[description]" class="form-control"
                            :class="{'is-invalid': errors.description}"
                            @blur="validate_description"
                            v-model="description"></textarea>
                  <div class="invalid-feedback">
                    Vous devez rensigner la description
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal">
                  <i class="fa fa-times" aria-hidden="true"></i>&nbsp;Annuler
                </button>
                <button
                    :disabled="submit_disabled == true"
                    type="submit"
                    class="btn btn-primary"
                    name="new_section">
                  <i class="fa fa-save" aria-hidden="true"></i>&nbsp;Valider
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="row mb-3">
        <div class="col-4">
          <button v-if="admin || group_status == 0 || group_status == 1"
                  type="button"
                  @click="new_section()"
                  class="btn btn-primary float-right ml-1">
            <i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Ajouter une section
          </button>
        </div>

<!--        <div class="col-4"></div>-->

<!--        &lt;!&ndash; SEARCH &ndash;&gt;-->
<!--        <div class="col-4">-->
<!--          <input v-on:keyup="search_sections" type="text" placeholder="Rechercher ..."-->
<!--                 class="form-control-sm w-100 border" v-model="query">-->
<!--        </div>-->
<!--        &lt;!&ndash; END SEARCH &ndash;&gt;-->

      </div>

      <table class="dlnkforums-topic-list">
        <thead>
        <tr>
          <th>Section</th>
          <th width="10">Topics</th>
          <th width="10">Posts</th>
          <th v-if="admin">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="section in sections"
            :key="section.id">
          <td @click="open_section(section)">
          <span>
            <a href="javascript:" class="dlnkforums-section-link">
              {{ section.name }}<br>
            </a>
          </span>
            <span>
            <br>
            {{ section.description }}
          </span>
          </td>
          <td>{{ section.topics_count }}</td>
          <td>{{ section.posts_count }}</td>
          <td v-if="admin">
            <a href="javascript:;"
               @click="edit_section(section)"
               class="text-info">
              <i aria-hidden="true" class="fa fa-edit"></i>
            </a>
            <a href="javascript:;"
               @click="delete_section(section.id)"
               class="text-danger">
              <i aria-hidden="true" class="fa fa-trash"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>

    </div>

    <div id="page_section" v-else-if="page=='section'">
      <dlnkforums-section
          v-on:goto_forum_index="page='sections'"
          :customer_id="customer_id"
          :group_id="group_id"
          :group_status="group_status"
          :admin="admin"
          :section="section"
          :base_url="base_url"
          @open_topic="open_topic($event)">
      </dlnkforums-section>
    </div>

    <div id="page_topic" v-else-if="page=='topic'">
      <dlnkforums-topic
          v-on:goto_section_index="page='section'"
          :base_url="base_url"
          :customer_id="customer_id"
          :group_id="group_id"
          :group_status="group_status"
          :admin="admin"
          :topic="topic">
      </dlnkforums-topic>
    </div>

  </div>
</template>

<script>

export default {
  props: [
    'base_url',
    'customer_id',
    'group_id',
    'group_status',
    'admin',
    'topic_id'
  ],
  data: function () {
    return {
      sections: [],
      topics: [],
      topic: Object,
      query: '',
      modal_title: '',
      message: false,
      message_type: '',
      method: '',
      section: Object,
      section_id: Number,
      name: '',
      description: '',
      page: 'sections',
      errors: {
        name: false,
        description: false
      }
    }
  },
  mounted() {
    this.get_sections()
    if (this.topic_id) {
      this.get_topic(this.topic_id)
    }
  },

  beforeDestroy () {
  },

  computed: {

    submit_disabled: function () {
      return this.errors.name || this.errors.description;
    }

  },

  methods: {

    get_topic: async function () {
      const _this = this;
      let api_url = this.base_url + "topics/" + this.topic_id + ".json";

      const secure_key = await get_token();
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.get(api_url)
          .then(function (response) {
            _this.topic = response.data
            _this.section_id = _this.topic.section.id
            _this.get_section()
            _this.open_topic(_this.topic)
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_section: async function () {
      const _this = this;
      let api_url = this.base_url + "sections/" + this.section_id + ".json";

      const secure_key = await get_token();
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.get(api_url)
          .then(function (response) {
            _this.section = response.data
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    edit_section: function(section) {
      this.section_id = section.id;
      this.name = section.name;
      this.description = section.description;
      this.method = 'patch'
      this.modal_title = "Modifier une section"

      this.validate_name();
      this.validate_description();

      $('#section_modal').modal('show');
    },

    new_section: function() {
      this.section_id = null;
      this.name = "";
      this.description = "";
      this.method = 'post'
      this.modal_title = "Ajouter une section"

      $('#section_modal').modal('show');
    },

    get_sections: async function () {

      const _this = this;
      let url = this.base_url +  "sections.json";

      const secure_key = await get_token();
      url += '?secure_key=' + secure_key;
      url += '&customer_id=' + this.customer_id;

      if (_this.group_id > 0) {
        url = url + "&group_id=" + _this.group_id;
      }

      axios.get(url)
          .then(function (response) {
            _this.sections = response.data
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    delete_section: async function (section_id) {
      const _this = this;
      let url = this.base_url + "sections/" + section_id ;

      const secure_key = await get_token();
      url += '?secure_key=' + secure_key;
      url += '&customer_id=' + this.customer_id;

      if (_this.group_id > 0) {
        url += "&group_id=" + _this.group_id;
      }

      axios.delete(url)
          .then(function (response) {
            _this.get_sections();
          })
          .catch(function (error) {
            if (error.response) {
              /*
               * The request was made and the server responded with a
               * status code that falls out of the range of 2xx
               */
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);

              _this.message = "";
              _this.message_type = 'alert-danger'
              for (var key in error.response.data) {
                _this.message += key + ' ' + error.response.data[key][0]
                _this.message += '<br>'
                /* use key/value for intended purpose */
              }

            } else if (error.request) {
              /*
               * The request was made but no response was received, `error.request`
               * is an instance of XMLHttpRequest in the browser and an instance
               * of http.ClientRequest in Node.js
               */
              console.log(error.request);
            } else {
              // Something happened in setting up the request and triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);

          })
          .then(function () {
                // always executed
              }
          );
    },

    open_section: function (section) {
      this.section = section;
      this.page = 'section';
    },

    open_topic: function (topic) {
      this.topic = topic;
      this.page = 'topic';
    },

    submit_section: async function () {
      const _this = this;
      let url = this.base_url + "sections";
      const secure_key = await get_token();

      if (_this.method == 'patch') {
        url += "/" + _this.section_id
      }

      const form_element = document.getElementById("section_form");
      const form_data = new FormData(form_element);
      form_data.append('secure_key', secure_key);
      form_data.append('customer_id', this.customer_id);

      axios({
        method: _this.method,
        url: url,
        data: form_data,
      })
          .then(function (response) {

            _this.message = "Section ajoutée";
            _this.message_type = 'alert-success';

            _this.get_sections();
            $('#section_modal').modal('hide');
          })
          .catch(function (error) {
            if (error.response) {
              /*
               * The request was made and the server responded with a
               * status code that falls out of the range of 2xx
               */
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);

              _this.message = "";
              _this.message_type = 'alert-danger'
              for (var key in error.response.data) {
                _this.message += key + ' ' + error.response.data[key][0]
                _this.message += '<br>'
                /* use key/value for intended purpose */
              }

            } else if (error.request) {
              /*
               * The request was made but no response was received, `error.request`
               * is an instance of XMLHttpRequest in the browser and an instance
               * of http.ClientRequest in Node.js
               */
              console.log(error.request);
            } else {
              // Something happened in setting up the request and triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);
          });
    },

    close_message: function () {
      this.message = null;
    },

    search_sections: function () {

    },

    validate_name: function () {
      this.errors.name = false;
      if (this.name.length < 3 || this.name.length > 128) {
        this.errors.name = true;
      }
    },

    validate_description: function () {
      this.errors.description = false;
      if (this.description.length < 3) {
        this.errors.description = true;
      }
    },

  }
}
</script>
